import React from 'react';
import { motion } from 'framer-motion';
export function OfferSection() {
  return <section id="oferta" className="py-32 px-6 bg-burgundy-deep relative overflow-hidden" data-id="element-102">
      {/* Subtle texture/glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,169,110,0.15)_0%,transparent_70%)]" data-id="element-103" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-104">
        <div className="bg-white/5 backdrop-blur-sm border border-gold/20 rounded-sm p-8 md:p-16 text-center shadow-2xl" data-id="element-105">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="mb-10" data-id="element-106">
            <img src="https://cdn.magicpatterns.com/uploads/9JswDS6959R6gFo2K5r1ka/ChatGPT_Image_Mar_11,_2026,_04_45_22_PM.png" alt="Deseo & Intimidad" className="w-48 md:w-64 mx-auto rounded-sm shadow-xl shadow-black/40 border border-gold/30 mb-8" data-id="element-107" />
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair text-cream mb-6 leading-tight" data-id="element-108">
              Reclama tu derecho biológico al placer y deja de vivir
              anestesiada.
            </h2>
            <p className="text-xl text-gold-light font-cormorant italic" data-id="element-109">
              Obtén el protocolo completo "Deseo & Intimidad: El Renacimiento"
              hoy mismo.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-110">
            <div className="inline-block border-y border-gold/30 py-4 px-8" data-id="element-111">
              <span className="text-cream/80 uppercase tracking-widest text-sm block mb-2" data-id="element-112">
                Inversión
              </span>
              <span className="text-5xl md:text-6xl font-playfair text-gold-bright" data-id="element-113">
                $6.39 <span className="text-2xl text-gold-light" data-id="element-114">USD</span>
              </span>
            </div>

            <div data-id="element-115">
              <motion.a href="https://www.novantumnexus.com/cart/53980807856403:1" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="inline-flex items-center justify-center w-full md:w-auto px-10 py-5 bg-gradient-to-r from-gold via-gold-bright to-gold text-burgundy-deep font-playfair font-bold tracking-wide text-xl rounded-full shadow-[0_0_40px_-10px_rgba(212,175,55,0.5)] transition-all duration-300 hover:shadow-[0_0_60px_-15px_rgba(212,175,55,0.7)]" data-id="element-116">
                RECLAMAR MI MAGNETISMO AHORA
              </motion.a>
              <p className="mt-6 text-cream/60 tracking-wide text-[12px]" data-id="element-117">
                -Descarga Ahora para Acceso Inmediato-
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}